import { type AnalyticsUrlsRecord } from "../services/analytics";
import { GF_POPUP_NOT_SHOW } from "../utils/constants";
import { setCookie } from "../utils/cookies";
import { createPopup } from "../utils/popup";
import { setButton, setElement } from "../utils/renders";
import { dayInMS } from "../utils/verifications";

const configUrl = "https://cdn.givefreely.com/gutenberg-popup/config.json";
const defaultConfig: Config = {
  isOn: true,
  hoursToShow: 24,
  repeatInAWeek: 3,
  repeatInAMonth: 6,
  installLink: "https://gvfr.ly/49U7Lzd",
  questionnaireLink: "https://gvfr.ly/3Px2XI6",
  millisecondsDelayedBeforePop: 15000,
  rolloutPercentage: 10,
  pageMatch:
    "^(https?:\\/\\/)?([a-zA-Z0-9-]+\\.)*gutenberg\\.org(?:\\/|\\/?\\?[^ ]*)?$",
  wording: {
    header: "Fundraising Experiment",
    title:
      "You rely upon Project Gutenberg to bring you great literature... please support us while also saving money for yourself!",
    copy: "Introducing Give Freely: A browser extension that saves you money while supporting our cause. Automatically apply coupons at over 10,000 stores, and the stores donate to us with every purchase. It's free, safe, and takes less than 60 seconds to install.",
    footer: "Try it now and generate an instant $10 donation to us!",
    cta: "Yes, I want to help Project Gutenberg, for FREE!",
    openFormBtn: "Share feedback on this experiment",
    closeBtn: "No Thanks",
    notShowBtn: "Please don't show me this again"
  }
};

const analyticsUrls: AnalyticsUrlsRecord = {
  onClose: "https://gvfr.ly/3TFPuQs",
  onOpen: "https://gvfr.ly/3IICL9y",
  onPermanentClose: "https://gvfr.ly/4903c52",
  onFailToLoadConfig: "https://gvfr.ly/3x4LNLz",
  onLoad: "https://gvfr.ly/499UCAN",
  onActivate: "",
  onInstallClick: ""
};

const analyticsEventId = "gutenberg";

createPopup(
  configUrl,
  defaultConfig,
  analyticsUrls,
  analyticsEventId,
  (config, container, analytics) => {
    setElement("gf-header", config.wording.header);
    setElement("gf-footer", config.wording.footer);
    setElement("gf-open-form-btn", config.wording.openFormBtn, config.questionnaireLink);
    setButton("gf-no-thanks-btn", config.wording.closeBtn, () => {
      analytics.onClose();
      container.remove();
    });
    setButton("gf-not-show-btn", config.wording.notShowBtn, () => {
      analytics.onPermanentClose();
      const expirationMaxTime = dayInMS * 400;
      setCookie(GF_POPUP_NOT_SHOW, true, expirationMaxTime);
      container.remove();
    });
  }
);
